module.exports = __webpack_public_path__ + "static/media/N01.3039ea54.svg";


//////////////////
// WEBPACK FOOTER
// ./src/img/N01.svg
// module id = 191
// module chunks = 0